import { Directions } from 'constants/directions';
import React from 'react';
import CenterButton from './CenterButton';
import DirectionalButton from './DirectionalButton';

type Props = {
  onUpClick: () => void;
  onDownClick: () => void;
  onLeftClick: () => void;
  onRightClick: () => void;
  onCenterClick: () => void;
};

const DirectionalPad: React.FC<Props> = ({
  onUpClick,
  onDownClick,
  onLeftClick,
  onRightClick,
  onCenterClick,
}: Props) => {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 44px)',
        gridTemplateRows: 'repeat(3, 44px)',
        filter: 'drop-shadow(0 2px 16px rgba(0, 116, 204, 0.08))',
      }}
    >
      <DirectionalButton direction={Directions.UP} onClick={onUpClick} />
      <DirectionalButton direction={Directions.DOWN} onClick={onDownClick} />
      <DirectionalButton direction={Directions.LEFT} onClick={onLeftClick} />
      <DirectionalButton direction={Directions.RIGHT} onClick={onRightClick} />
      <CenterButton onClick={onCenterClick} />
    </div>
  );
};

export default DirectionalPad;
